import { z } from 'zod';

export const moneySchema = z.object({
  amount: z.number(),
  currency: z.union([z.literal('SEK'), z.literal('GBP')])
});
